<template>
  <div class="contain">
    <img class="gp_title" :src="$img( 'lx.png' )" />

    <div class="wrap">
      <img :src="$img( 'tag.png' )" class="tag-bt">
      <div class="ban">
        <div id="map"></div>
        <div class="cont clear">
          <div class="lc fl">
            <h6>联系方式</h6>
            <div class="clear">
              <div class="item">
                <img :src="$img( 'phone.png' )" />
                联系人：{{data.people}}
              </div>
              <div class="item">
                <img :src="$img( 'cu.png' )" />
                电话：{{data.phone}}
              </div>
              <div class="item">
                <img :src="$img( 'em.png' )" />
                邮箱：{{data.email}}
              </div>
            </div>
          </div>
          <img class="lr fr" :src="$img( 'qcore.png' )" />
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  props: ['data'],
  watch: {
    data (val) {
      if (val) {
        setTimeout(() => {
          // 百度地图API功能
          const map = new BMap.Map('map')
          // 创建地址解析器实例
          const myGeo = new BMap.Geocoder()
          // 将地址解析结果显示在地图上,并调整地图视野
          myGeo.getPoint('广东省广州市番禺区兴业大道龙泉山庄旁绿道水泥地走800米，迷恋之约犬舍', function (point) {
            if (point) {
              map.centerAndZoom(point, 16)
              map.addOverlay(new BMap.Marker(point))
              const infoWindow = new BMap.InfoWindow('广东省广州市番禺区兴业大道龙泉山庄旁绿道水泥地走800米，迷恋之约犬舍')
              map.openInfoWindow(infoWindow,point)
            }
          }, '广州市')
        }, 300)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.contain {
  position: relative;
  height: 100%;
  background: url('../assets/images/cs_bg.png');
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.gp_title {
  position: absolute;
  top: 20px;
  left: calc( 50% - 155px );
}

.wrap {
  position: relative;
  width: 980px;
  height: 570px;
  background: #fff;
  margin: 0 auto;
  position: relative;
  box-shadow: 0 4px 8px 0 rgba(7,17,27,.1);
  top: 204px;
  padding: 14px 0;
  .tag-bt {
    position: absolute;
    top: -28px;
    left: 0;
  }
}

.ban {
  width: 100%;
  height: 100%;
  padding: 0px 50px;
}

#map {
  width: 100%;
  height: 430px;
  margin-bottom: 24px;
}

#r-result {
  font-size: 14px;
}

.cont {
  height: 70px;
  .lc {
    h6 {
      font-size: 18px;
      color: #c18e44;
      margin-bottom: 20px;
    }
    .item {
      font-size: 14px;
      display: inline-block;
      margin-right: 36px;
      img {
        position: relative;
        top: 4px;
        display: inline-block;
      }
    }
  }
}
</style>
